import { DashboardModule } from '@domain-group/suit-theme'

import useBrandGroups from '@hooks/useBrandGroups'

import type { BrandGroupModel } from '@models/types'

import AgencyBrandGroupListItem from './AgencyBrandGroupListItem'

const AgencyBrandGroups = (props: { agencyId: number }) => {
  const { agencyId } = props

  const brandGroupsPayload = useBrandGroups({
    filters: {
      agency_id: agencyId,
    },
    performHttpRequests: !!agencyId,
    requestOptions: {
      include_brand_group_member_ids: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredBrandGroups,
    filteredBrandGroupsCount,
    hasFilteredBrandGroups,
    loading,
  } = brandGroupsPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Brand Groups"
    >
      {!loading && !hasFilteredBrandGroups && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Brand Groups present.
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please assign a Brand Group.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredBrandGroups && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection flexDirection="column">
          {filteredBrandGroups.map((brandGroup: BrandGroupModel) => (
            <AgencyBrandGroupListItem
              key={brandGroup.id}
              brandGroup={brandGroup}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredBrandGroupsCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default AgencyBrandGroups
